<div fxLayout="row wrap" class="res-item qs-form-build">
    <mat-accordion
        class="resources-list"
        fxFlex="0 1 100%"
        fxFlex.lt-lg="100%"
        fxFlex.lt-md="100%"
        cdkDropList
        [multi]="true"
        #accordion
        (cdkDropListDropped)="drop($event.previousIndex, $event.currentIndex)"
    >
        <mat-expansion-panel
            *ngFor="let item of itemFormArray.controls; let i = index"
            #panel
            class="item no-shadow"
            [class.disabled]="item.disabled"
            cdkDrag
            cdkDragLockAxis="y"
            [expanded]="expanded === i || allExpanded"
            (opened)="onOpen(i)"
            [disabled]="item.disabled"
        >
            <mat-expansion-panel-header
                [collapsedHeight]="'60px'"
                [expandedHeight]="'60px'"
                class="question-header res-item-header"
                [ngClass]="{ 'header-test-expanded': item.value.item_type_value == 'test' }"
            >
                <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
                    <div
                        fxFlex="0 1 auto"
                        class="question-title-index"
                        [ngClass]="{ 'wok-qus': item.get('question')?.value['isWOKQs'] }"
                    >
                        {{ i + 1 }}
                    </div>
                    <div fxFlex="0 1 auto" fxLayout="column" class="item-desc">
                        <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
                            <ng-container [ngSwitch]="displayCorrectIcon(item.get('item_type_value').value)">
                                <span
                                    *ngSwitchCase="'e-course'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-player"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.E_COURSE, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'course'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-task"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.COURSE, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'test'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-test"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.TEST, id: item.value.id }"
                                    ></span>
                                    <span class="children-count"
                                        ><span>(</span>
                                        <span>{{ items[i].child_resource_items_count }}</span>
                                        <mat-icon>help_outline</mat-icon>
                                        <span>)</span>
                                    </span>
                                </span>
                                <span
                                    *ngSwitchCase="'survey'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-survey"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.SURVEY, id: item.value.id }"
                                    ></span>
                                    <span class="children-count"
                                        ><span>(</span>
                                        <span>{{ items[i].child_resource_items_count }}</span>
                                        <mat-icon>help_outline</mat-icon>
                                        <span>)</span>
                                    </span>
                                </span>
                                <span
                                    *ngSwitchCase="'event'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon>event</mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.EVENT, id: item.value.id }"
                                    ></span>
                                    <span class="children-count"
                                        ><span>(</span>
                                        <span>{{ items[i].child_resource_items_count }}</span>
                                        <mat-icon>auto_awesome_motion</mat-icon>
                                        <span>)</span>
                                    </span>
                                </span>
                                <span
                                    *ngSwitchCase="'scorm'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon>business_center</mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.SCORM, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'doc'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-document"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.MATERIAL, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'url'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-document"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.MATERIAL, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'text'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-document"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.MATERIAL, id: item.value.id }"
                                    ></span>
                                </span>
                                <span
                                    *ngSwitchCase="'material'"
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxFlex="0 1 auto"
                                >
                                    <mat-icon fontSet="klickdata" fontIcon="kd-icon-document"></mat-icon>

                                    <span
                                        [ngTemplateOutlet]="childResourceNameTranslation"
                                        [ngTemplateOutletContext]="{ scope: AppScope.MATERIAL, id: item.value.id }"
                                    ></span>
                                    <span class="children-count"
                                        ><span>(</span>
                                        <span>{{
                                            items[i].child_resource_items_count ?? item.value.child_resource_items_count
                                        }}</span>
                                        <mat-icon>auto_awesome_motion</mat-icon>
                                        <span>)</span></span
                                    >
                                </span>
                            </ng-container>
                        </div>

                        <p
                            *ngIf="!panel.expanded"
                            fxFlex="0 1 auto"
                            [matTooltip]="getScormItemFileOrigin(item.value.id)"
                            [ngClass]="{
                                'item-hidden': !(item.get('metadata.visibility')?.value ?? true)
                            }"
                            [style.opacity]="item.get('metadata.visibility')?.value ?? true ? 1 : 0.5"
                        >
                            {{ item.get('title').value ?? item.get('name').value }}
                        </p>
                    </div>
                </mat-panel-title>

                <mat-panel-description class="btns-desc" fxLayout="row" fxLayoutAlign="end center">
                    <ng-container *ngIf="isTest(item.value.item_type_value)">
                        <!-- Passing Level -->

                        <button
                            *ngIf="panel.expanded"
                            mat-icon-button
                            color="primary"
                            matTooltip="Exchange"
                            i18n-matTooltip="@@exchange"
                            (click)="$event.stopPropagation(); change()"
                        >
                            <mat-icon>swap_horiz</mat-icon>
                        </button>
                        <!-- View correct answers -->
                        <button
                            *ngIf="panel.expanded || !!item.value.show_correct_alts"
                            [matTooltip]="getCorrectAnswersTooltip(item.value.show_correct_alts)"
                            i18n-matTooltip
                            (click)="$event.stopPropagation()"
                            mat-icon-button
                            [matMenuTriggerFor]="showCorrectAnswersMenu"
                            [ngClass]="{
                                grey: !item.value.show_correct_alts || item.value.show_correct_alts == 'always',
                                green:
                                    item.value.show_correct_alts == 'never' || item.value.show_correct_alts == 'passed'
                            }"
                        >
                            <mat-icon matSuffix>task_alt</mat-icon>
                        </button>

                        <mat-menu
                            #showCorrectAnswersMenu="matMenu"
                            class="passing-menu-panel correct-alt-menu"
                            [hasBackdrop]="true"
                            [overlapTrigger]="false"
                        >
                            <mat-radio-group
                                [formControl]="item.get('show_correct_alts') | cast"
                                class="correct-alt-options"
                                fxLayout="column"
                                fxLayoutGap="10px"
                            >
                                <mat-radio-button i18n value="always">Always</mat-radio-button>
                                <mat-radio-button *ngIf="item.value.percentage > 0" i18n value="passed"
                                    >Only if passing level achieved</mat-radio-button
                                >
                                <mat-radio-button i18n value="never">Never</mat-radio-button>
                            </mat-radio-group>
                        </mat-menu>
                        <!-- Passing Level -->
                        <button
                            *ngIf="panel.expanded || !!item.value.percentage"
                            [matTooltip]="getPassingLevelLabel(item.value)"
                            i18n-matTooltip
                            (click)="$event.stopPropagation()"
                            mat-icon-button
                            [matMenuTriggerFor]="passingLevelMenu"
                            [ngClass]="{
                                grey: !item.value.percentage || item.value.percentage == 0,
                                green: item.value.percentage && item.value.percentage > 0
                            }"
                        >
                            <mat-icon matSuffix>private_connectivity</mat-icon>
                        </button>

                        <mat-menu
                            #passingLevelMenu="matMenu"
                            class="passing-menu-panel percent"
                            [hasBackdrop]="true"
                            [overlapTrigger]="false"
                        >
                            <div class="tooltip-content" matMenuCloseOnClick="false">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <span i18n>Passing percentage</span>
                                    <mat-slide-toggle
                                        color="accent"
                                        [checked]="!!item.value.percentage && item.value.percentage > 0"
                                        (click)="$event.stopPropagation()"
                                        (change)="setPassingLevel($event.checked, item)"
                                    >
                                    </mat-slide-toggle>
                                </div>

                                <mat-form-field
                                    *ngIf="!!item.value.percentage && item.value.percentage > 0"
                                    class="passing-data"
                                >
                                    <input
                                        matInput
                                        type="number"
                                        min="0"
                                        [formControl]="item.get('percentage') | cast"
                                        (click)="$event.stopPropagation()"
                                    />
                                    <span matTextSuffix>%</span>
                                </mat-form-field>
                            </div>
                        </mat-menu>

                        <!-- Repeats -->
                        <button
                            *ngIf="panel.expanded || !!item.value.repeats"
                            [matTooltip]="getRepeatsLabel(item.value)"
                            (click)="$event.stopPropagation()"
                            mat-icon-button
                            [matMenuTriggerFor]="repeatsMenu"
                            [ngClass]="{
                                grey: item.value.repeats == null,
                                red: item.value.repeats == 0,
                                green: item.value.repeats && item.value.repeats > 0
                            }"
                        >
                            <mat-icon matSuffix>restart_alt</mat-icon>
                        </button>

                        <mat-menu
                            #repeatsMenu="matMenu"
                            class="passing-menu-panel"
                            [hasBackdrop]="true"
                            [overlapTrigger]="false"
                        >
                            <div class="tooltip-content" matMenuCloseOnClick="false">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <span i18n>Retry Limits</span>
                                    <mat-slide-toggle
                                        color="accent"
                                        [checked]="item.value.repeats == null"
                                        (click)="$event.stopPropagation()"
                                        (change)="
                                            $event.checked
                                                ? item.get('repeats').patchValue(null)
                                                : item.get('repeats').patchValue(0)
                                        "
                                    >
                                    </mat-slide-toggle>
                                </div>
                                <mat-form-field *ngIf="item.value.repeats != null" class="passing-data">
                                    <input
                                        matInput
                                        type="number"
                                        min="0"
                                        [formControl]="item.get('repeats') | cast"
                                        (click)="$event.stopPropagation()"
                                    />
                                </mat-form-field>
                            </div>
                        </mat-menu>
                    </ng-container>

                    <button
                        mat-icon-button
                        *ngIf="editable(items[i]) && item.disabled"
                        (click)="toggleDisable($event, item); panel.close()"
                    >
                        <mat-icon fxFlex="0 1 auto" class="remove-item"> undo </mat-icon>
                    </button>

                    <!-- The ngIf directive for preventing appearance in type question -->
                    <button
                        *ngIf="!item.disabled"
                        (click)="
                            $event.stopPropagation();
                            item.get('metadata.visibility').patchValue(!item.value.metadata.visibility);
                            item.markAsDirty()
                        "
                        class="tools-btn"
                        mat-icon-button
                        [matTooltip]="
                            item.value.metadata.visibility
                                ? 'Make it hidden while playing'
                                : 'Make it visible while playing'
                        "
                        i18n-matTooltip
                    >
                        <mat-icon>{{ item.value.metadata.visibility ? 'visibility' : 'visibility_off' }}</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="tools-btn-icon other-tools-btn"
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="otherToolsMenu"
                        #otherToolsMenuTrigger="matMenuTrigger"
                        (menuOpened)="onMenuOpened(i)"
                        i18n-matTooltip="@@otherTools"
                        matTooltip="Other tools"
                    >
                        <mat-icon class="kd-icon-24">spoke</mat-icon>
                    </button>
                    <mat-menu
                        #otherToolsMenu="matMenu"
                        [hasBackdrop]="true"
                        [overlapTrigger]="false"
                        backdropClass="other-tools-menu-backdrop"
                    >
                        <ng-container *ngIf="isMenuLoaded(i)">
                            <button
                                *ngIf="!item.disabled && editable(items[i])"
                                mat-button
                                (click)="duplicate($event, item); otherToolsMenuTrigger.closeMenu()"
                            >
                                <mat-icon fxFlex="0 1 auto" class="duplicate-item"> content_copy </mat-icon>
                                <span i18n>Duplicate</span>
                            </button>
                            <a
                                *ngIf="!!item.value.child_resource_id"
                                matTooltip="Preview"
                                i18n-matTooltip="@@preview"
                                mat-button
                                [routerLink]="['/player/resource/', item.value.child_resource_id]"
                                target="_blank"
                            >
                                <mat-icon> open_in_new </mat-icon>
                                <span i18n>Preview</span>
                            </a>
                            <button
                                mat-button
                                matTooltip="Update to the last version"
                                i18n-matTooltip
                                *ngIf="item.value.child_resource_id"
                                (click)="
                                    $event.stopPropagation(); updateResource(item); otherToolsMenuTrigger.closeMenu()
                                "
                            >
                                <mat-icon fxFlex="0 1 auto" class="remove-item"> update </mat-icon>
                                <span i18n>Update</span>
                            </button>
                            <button
                                mat-button
                                #tooltip="matTooltip"
                                [matTooltip]="getItemInfo(items[i]) | async"
                                (click)="$event.stopPropagation(); tooltip.toggle()"
                                (mouseenter)="tooltip.show()"
                                matTooltipClass="info-tooltip"
                                *ngIf="item.value.child_resource_id"
                            >
                                <mat-icon fxFlex="0 1 auto" class="remove-item"> info </mat-icon>
                                <span i18n>Info</span>
                            </button>
                            <button
                                mat-button
                                *ngIf="editable(items[i])"
                                (click)="toggleDisable($event, item); panel.close(); otherToolsMenuTrigger.closeMenu()"
                            >
                                <mat-icon *ngIf="!item.disabled" fxFlex="0 1 auto" class="remove-item">
                                    delete
                                </mat-icon>
                                <span i18n>Delete</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                    <app-language-selector
                        *ngIf="items[i].child_resource_language_id"
                        class="icon-resource-builder"
                        fxFlex="0 1 auto"
                        (click)="$event.stopPropagation()"
                        [formControl]="item.get('child_resource_language_id') | cast"
                    ></app-language-selector>

                    <mat-icon
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="orderMenu"
                        #orderMenuTrigger="matMenuTrigger"
                        cdkDragHandle
                        matTooltip="Sorting / Drag and drop or click"
                        i18n-matTooltip
                        fxFlex="0 1 auto"
                        class="question-reorder"
                    >
                        reorder
                    </mat-icon>
                    <mat-menu
                        #orderMenu="matMenu"
                        class="passing-menu-panel correct-alt-menu"
                        [hasBackdrop]="true"
                        [overlapTrigger]="false"
                    >
                        <div fxLayout="column" fxLayoutAlign="start start" class="sorting-prio-menu">
                            <span i18n>Sorting priority</span>
                            <mat-form-field class="passing-data">
                                <mat-label i18n>Enter sorting priority</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    min="0"
                                    [formControl]="sortingPrio | cast"
                                    (click)="$event.stopPropagation()"
                                />
                            </mat-form-field>
                            <button
                                color="primary"
                                mat-button
                                [disabled]="sortingPrio.value == null || sortingPrio.value == 0"
                                (click)="
                                    orderMenuTrigger.closeMenu(); drop(i, sortingPrio.value - 1); sortingPrio.reset()
                                "
                                matMenuClose
                            >
                                <span i18n>Done</span>
                            </button>
                        </div>
                    </mat-menu>

                    <button
                        *ngIf="editable(items[i]) && panel.expanded"
                        mat-icon-button
                        color="primary"
                        matTooltip="Edit"
                        i18n-matTooltip="@@edit"
                        [disabled]="!editable(items[i])"
                        (click)="$event.stopPropagation(); onEdit(items[i])"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>

                    <!-- Mandatory -->
                    <button
                        [matTooltip]="getTooltipText(sliderToggle.checked)"
                        i18n-matTooltip
                        (click)="$event.stopPropagation()"
                        mat-icon-button
                        [matMenuTriggerFor]="mandatoryMenu"
                        [ngClass]="{
                            grey: !item.value.mandatory,
                            green: item.value.mandatory
                        }"
                    >
                        <mat-icon>alt_route</mat-icon>
                    </button>

                    <mat-menu
                        #mandatoryMenu="matMenu"
                        class="mandatory-menu-panel percent"
                        [hasBackdrop]="true"
                        [overlapTrigger]="false"
                    >
                        <div class="tooltip-content" matMenuCloseOnClick="false">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <span i18n>Mandatory</span>
                                <mat-slide-toggle
                                    #sliderToggle
                                    class="ml-1 mandatory-toggle"
                                    color="accent"
                                    [checked]="item.get('mandatory')?.value"
                                    [formControl]="item.get('mandatory') | cast"
                                    (click)="$event.stopPropagation()"
                                >
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </mat-menu>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <app-resource-item-form
                #res_item_ref
                *ngIf="panel.expanded && item.get('item_type_value').value !== 'material'"
                [itemGroup]="item | cast"
                [item]="items[i]"
                [index]="i"
                [usePoints]="usePoints"
                (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
            ></app-resource-item-form>
            <app-resource-item-material-form
                #res_item_ref_material
                *ngIf="panel.expanded && item.get('item_type_value').value === 'material'"
                [childGroup]="item | cast"
                [item]="items[i]"
                (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
            ></app-resource-item-material-form>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<ng-template #childResourceNameTranslation let-scope="scope" let-id="id">
    {{ { scope_id: scope } | resourceDefaultNameDisplay : false : getChildResourceNameTranslation(id) | async }}
</ng-template>
